import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import inputErrors from '../../helpers/validation'
import { saveProfile } from '../../../redux/reducers/profileSlice';
import EditIcon from '@mui/icons-material/Edit';
import { ReactComponent as EkOnkarIcon } from '../../../images/ekonkar.svg';
import { ReactComponent as GanpatiIcon } from '../../../images/ganpati2.svg';
import { ReactComponent as KhandaIcon } from '../../../images/khanda.svg';
import { ReactComponent as OmIcon } from '../../../images/om.svg';
import { ReactComponent as CrossIcon } from '../../../images/cross.svg';
import { ReactComponent as BismillahIcon } from '../../../images/bismillah.svg';
import { ReactComponent as NoneIcon } from '../../../images/none.svg';
import { ReactComponent as WaipIcon } from '../../../images/waip.svg';
import { ReactComponent as RingsIcon } from '../../../images/rings.svg';
import { ReactComponent as KnotIcon } from '../../../images/knot.svg';
import { ReactComponent as SwastikIcon } from '../../../images/swastik.svg';
import { ReactComponent as BuddhaIcon } from '../../../images/buddha.svg';
import TopFlap from '../FinalOutput/Components/Envelope/Topflap';
import BottomFlap from '../FinalOutput/Components/Envelope/BottomFlap';
import LeftFlap from '../FinalOutput/Components/Envelope/LeftFlap';
import RightFlap from '../FinalOutput/Components/Envelope/RightFlap';
import './envelopeform.css'


const iconMapping = {
    EkOnkarIcon,
    GanpatiIcon,
    OmIcon,
    KhandaIcon,
    CrossIcon,
    BismillahIcon,
    WaipIcon,
    RingsIcon,
    KnotIcon,
    SwastikIcon,
    BuddhaIcon,
    None: NoneIcon,
};





const ENVELOPE_DETAILS_FIELDS = [
    "coverText",
    "withRegards",
    "withRegardsTitle"
];

const ENVELOPE_DETAILS_FIELDS_NO_BOTTOM = [
    "coverText",
];

const EnvelopeForm = ({ onBack, onNext }) => {
    const formRef = useRef(null);
    const dispatch = useDispatch()
    const { weddingData: profileData} = useSelector((state) => state.profile)
    const [errors, setErrors] = useState({})
    const [values, setValues] = useState({
        coverIcon: "",
        coverText: "",
        withRegards: "",
        withRegardsTitle: ""
    })
    const [isSubmitting, setSubmitting] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault()

        const envelopeDetailsFeild=
        profileData?.userCode === "odto969rk"
        ? ENVELOPE_DETAILS_FIELDS_NO_BOTTOM:
         ENVELOPE_DETAILS_FIELDS;

         const validationErrors = inputErrors(
        values,
         envelopeDetailsFeild
    );
        setErrors(validationErrors)
        setSubmitting(true)
    }
    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    }
    const handleIconSelect = (icon) => {
        setValues({
            ...values,
            coverIcon: icon
        })
    };

    const savedata = () => {
        setSubmitting(false)
        dispatch(saveProfile({ values, onNext }))
    }

    const Icon = ({ className }) => {
        const Component = iconMapping[values.coverIcon];

        if (!Component) return null;

        return <Component className={className} />;
    };

    useEffect(() => {
        setValues({ ...profileData })
    }, [profileData])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        if (isSubmitting) {
            const noErrors = Object.keys(errors).length === 0;
            if (noErrors) {
                savedata()
            } else {
                formRef.current.scrollIntoView({ behavior: "smooth" });
            }

        }
    }, [isSubmitting, errors])


//       const stampImage = {
//   theme1:
//     "/stamp.png",

//   theme2:
//     "/theme2-stamp.png",

//   theme3:
//     "/theme3-stamp.png",

//   theme4:
//     "/theme-4-stamp.png",

//     theme5:
//      "/theme3-stamp.png",
// };
const stampImage = {
  theme1:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1792805549/aamantran%20assets/stamp_fzb6qr.png",

  theme2:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1792806588/aamantran%20assets/theme2-stamp_e6ab55.png",

  theme3:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1792806687/aamantran%20assets/theme3-stamp_ttujeb.png",

  theme4:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1792806745/aamantran%20assets/theme-4-stamp_rkprpw.png",

  theme5:
    "https://res.cloudinary.com/depixc8dq/image/upload/v1792806687/aamantran%20assets/theme3-stamp_ttujeb.png",
};


const defaultStamp = stampImage.theme1;

const SealImage = stampImage[values?.theme] || defaultStamp;

const isCloudinaryStamp = SealImage.includes("res.cloudinary.com");

const getOptimizedStampUrl = (url, width) =>
  url.replace("/upload/", `/upload/f_auto,q_auto,w_${width}/`);

const stampSrcSet = isCloudinaryStamp
  ? `
      ${getOptimizedStampUrl(SealImage, 160)} 160w,
      ${getOptimizedStampUrl(SealImage, 200)} 200w,
      ${getOptimizedStampUrl(SealImage, 320)} 320w,
      ${getOptimizedStampUrl(SealImage, 450)} 450w
    `
  : undefined;

const stampSrc = isCloudinaryStamp
  ? getOptimizedStampUrl(SealImage, 200)
  : SealImage;


    return (
        <>
            {/* <Progress activeStep={3} demoVersion={user && user.demoVersion} /> */}
            <div className="form-screen">
                <div className="container mb-3">
                    <div className="row d-flex row-containers  mx-2">
                        <div className="col-lg-6 col-md-11 form-container">
                            {/* <h3 className='form-heading'> Cover </h3> */}
                            <form className='form-div' onSubmit={handleSubmit} ref={formRef} >
                                <div className="religious-element-container">
                                    <h3 className="form-heading-theme">Cover Icon</h3>
                                    {/* <OverlayTrigger placement="auto" overlay={
                                            <Tooltip id="tooltip-group">
                                                <span>
                                                    Choose a religious symbol or use the default icons or none for no icon. Add a short text accordingly!
                                                </span>
                                            </Tooltip>
                                        }>
                                            <InfoIcon className='tooltip-icon' />
                                        </OverlayTrigger> */}

                                    <div className="icon-selection d-flex align-items-center">
                                        {/* <div className="icon-display">{displayedIcon}</div> */}
                                        <div className="icon-display">
                                            <Icon />
                                        </div>
                                        <EditIcon className='edit-reli-icon' data-bs-toggle="modal" data-bs-target="#iconModal" />
                                    </div>
                                </div>
                                <div className="religious-text-field mt-3">
                                    <span className='religous-text-label'>Cover text </span>
                                    <textarea
                                        name="coverText"
                                        value={values.coverText}
                                        onChange={handleChange}
                                        placeholder="Enter short text"
                                        rows="2"
                                        className="form-control"
                                    />
                                </div>
                                <div className='error-wedding-div p-2 error-center' >  {errors.coverText && (<small className="error-msg-wedding">{errors.coverText}</small>)}</div>
                                <div
                                    className="modal fade"
                                    id="iconModal"
                                    tabIndex="-1"
                                    aria-labelledby="iconModalLabel"
                                    aria-hidden="true"
                                >
                                    <div className="modal-dialog modal-dialog-scrollable">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="iconModalLabel">Select Religious Icon</h5>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                ></button>
                                            </div>

                                            <div className="modal-body">
                                                <div className="icon-options d-flex flex-wrap gap-3">
                                                    {/* Option for no icon */}
                                                    <div className="icon-option" onClick={() => handleIconSelect("None")}>
                                                        <NoneIcon />
                                                    </div>
                                                    <div className="icon-option" onClick={() => handleIconSelect("RingsIcon")}>
                                                        <RingsIcon />
                                                    </div>
                                                    <div className="icon-option" onClick={() => handleIconSelect("KnotIcon")}>
                                                        <KnotIcon />
                                                    </div>
                                                    <div className="icon-option" onClick={() => handleIconSelect("GanpatiIcon")}>
                                                        <GanpatiIcon />
                                                    </div>
                                                    <div className="icon-option" onClick={() => handleIconSelect("OmIcon")}>
                                                        <OmIcon />
                                                    </div>
                                                    <div className="icon-option" onClick={() => handleIconSelect("EkOnkarIcon")}>
                                                        <EkOnkarIcon />
                                                    </div>
                                                    <div className="icon-option" onClick={() => handleIconSelect("KhandaIcon")}>
                                                        <KhandaIcon />
                                                    </div>
                                                    <div className="icon-option" onClick={() => handleIconSelect("CrossIcon")}>
                                                        <CrossIcon />
                                                    </div>
                                                    <div className="icon-option" onClick={() => handleIconSelect("BismillahIcon")}>
                                                        <BismillahIcon />
                                                    </div>
                                                    <div className="icon-option" onClick={() => handleIconSelect("WaipIcon")}>
                                                        <WaipIcon />
                                                    </div>
                                                    <div className="icon-option" onClick={() => handleIconSelect("SwastikIcon")}>
                                                        <SwastikIcon />
                                                    </div>
                                                    <div className="icon-option" onClick={() => handleIconSelect("BuddhaIcon")}>
                                                        <BuddhaIcon />
                                                    </div>
                                                    {/* Add more icons here similarly */}
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                {/* <button type="button" onClick={() => redirectToWhatsApp()} className="btn btn-primary" >
                                                                           Missing an icon? Let us know!
                                                                       </button> */}
                                                <button type="button" className="btn btn-primary" data-bs-dismiss="modal">
                                                    Select
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={errors.withRegardsTitle ? "form-input-div-error" : "form-input-div"}>
                                    <input type="search"
                                        name="withRegardsTitle"
                                        value={values.withRegardsTitle}
                                        onChange={handleChange}
                                        placeholder=' '
                                        className={errors.withRegardsTitle ? "form-input-field-error" : "form-input-field"}
                                    />
                                    <label>Closing Line(optional):</label>
                                </div>
                                <div className='error-wedding-div'>  {errors.withRegardsTitle && (<small className="error-msg-wedding">{errors.withRegardsTitle}</small>)}</div>

                                <div className={errors.withRegards ? "form-input-div-error" : "form-input-div"}>
                                    <input type="search"
                                        name="withRegards"
                                        value={values.withRegards}
                                        onChange={handleChange}
                                        placeholder=' '
                                        className={errors.withRegards ? "form-input-field-error" : "form-input-field"}
                                    />
                                    <label>From (optional):</label>
                                </div>
                                <div className='error-wedding-div'>  {errors.withRegards && (<small className="error-msg-wedding">{errors.withRegards}</small>)}</div>

                                <div className='form-double-buttons'>
                                    <button type='button' onClick={onBack} >Back</button>
                                    <button type='submit'>Save</button>
                                </div>
                            </form>
                        </div>
                        <div className="col-md-12 preview-container-bg envelope-screen-preview-container">
                            <div className={`preview-envelope-screen ${values?.theme || ''}`}>
                                <div className="envelope-seal">
                                    {/* <img
                                        src={SealImage}
                                        alt="Seal"
                                    /> */}
 <img
    src={stampSrc}
    srcSet={stampSrcSet}
    sizes="(min-width: 1000px) 150px, (min-width: 767px) 140px, (min-width: 424px) 200px, 160px"
    alt="Seal"
  />

                                </div>
                                <div className="top-area">
                                    <div className="preview-top-area-content">
                                       <Icon className="preview-top-area-icon" />
                                        {/* <GanpatiIcon className="preview-top-area-icon" /> */}

                                        <span>{values.coverText}</span>
                                        {/* <span>॥ श्री गणेशाय नमः ॥</span> */}
                                    </div>
                                </div>

                                <div className="preview-bottom-area-content">

                                    <span className="preview-bottom-title">
                                        {values.withRegardsTitle}
                                    </span>

                                    <span className="preview-bottom-name">
                                        {values.withRegards}
                                    </span>

                                </div>
                                <TopFlap />
                                <BottomFlap />
                                <LeftFlap />
                                <RightFlap />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EnvelopeForm